// tslint:disable max-line-length

import * as Constants from "Data/Constants";
import {RIO as VO} from "Data/VO";
import type {ILocationConfig} from "Interfaces/ILocationConfig";

export const DelhiConfig: ILocationConfig = {
  city: "Delhi",
  country: "India",
  interior: {
    width: 1664,
    itemslist: {
      give: {
        bg: [
          { filename: "table-receive", x: -5.5 / 2, y: 286 / 2, dontAnimateIn: true },
          { filename: "screen-list", x: 9 / 2, y: -62 / 2 },
          { filename: "screen-rope-left", x: -925 / 2, y: -507 / 2 },
          { filename: "screen-rope-right", x: 891 / 2, y: -591.5 / 2 },
        ],
        ICON_SIZE: 140,
        ICON_SPACING: 8,
        columns: 4,
        floatingItemsY: -180,
        width: 1168 / 2,
        highlightFloatingItems: false,
        animateIn: "slideInFromTop",
      },
      return: {
        width: 0,
        height: 0,
        highlightFloatingItems: true,
        floatingItemsY: -130,
        returnItemAnchorY: 1,
        ICON_SIZE: 120,
        ICON_SPACING: 10,
        itemslots: [
          {
            x: 0,
            y: 130,
            width: 565,
            height: 120,
            acceptsMultiple: true,
            keepItemIcons: true,
            hideIconImmediately: false,
            bg: [{ filename: "table-return", x: 0, y: 110 }],
            dropSFX: "powerup-shield",
          },
        ],
        animateOut: "danceParty",
      },
    },
    bg: { filename: "delhi-int-bg" },
  },
  exterior: {
    bg: [
      { filename: "delhi-ext-bg1", x: 0, y: 0 },
      { filename: "delhi-ext-bg2", x: 2048, y: 0 },
    ],
    margin: {
      left: 10,
      right: 10,
    },
    width: 3072,
  },
  items: {
    "balloon": {
      name: "Balloon",
      sprite: "balloon-full",
      sprite_hat: "balloon-full",
      icon_int_give: "balloon-full",
      icon_int_return: "balloon-full",
      icon_ext: "balloon-on",
      vo: {
        found: VO.IR2B,
        returned: VO.IR2A,
        fact: VO.FR8,
      },
    },
    "boom-box": {
      name: "Boom Box",
      sprite: "boom-box-full",
      sprite_hat: "boom-box-full",
      icon_int_give: "boom-box-full",
      icon_int_return: "boom-box-full",
      icon_ext: "boom-box-on",
      vo: {
        found: VO.IR9B,
        returned: VO.IR9A,
      },
    },
    "cake": {
      name: "Cake",
      sprite: "cake-full",
      sprite_hat: "cake-full",
      icon_int_give: "cake-full",
      icon_int_return: "cake-full",
      icon_ext: "cake-on",
      vo: {
        found: VO.IR4B,
        returned: VO.IR4A,
        fact: VO.FR10,
      },
    },
    "kathputli": {
      name: "Kathputli",
      sprite: "kathputli-full",
      sprite_hat: "kathputli-full",
      icon_int_give: "kathputli-full",
      icon_int_return: "kathputli-full",
      icon_ext: "kathputli-on",
      vo: {
        found: VO.IR7B,
        returned: VO.IR7A,
      },
    },
    "laddu": {
      name: "Laddu",
      sprite: "laddu-full",
      sprite_hat: "laddu-full",
      icon_int_give: "laddu-full",
      icon_int_return: "laddu-full",
      icon_ext: "laddu-on",
      vo: {
        found: VO.IR1B,
        returned: VO.IR1A,
        fact: VO.FR7,
      },
    },
    "lassi-drink": {
      name: "Lassi Drink",
      sprite: "lassi-drink-full",
      sprite_hat: "lassi-drink-full",
      icon_int_give: "lassi-drink-full",
      icon_int_return: "lassi-drink-full",
      icon_ext: "lassi-drink-on",
      vo: {
        found: VO.IR5B,
        returned: VO.IR5A,
      },
    },
    "new-outfit": {
      name: "New Outfit",
      sprite: "new-outfit-full",
      sprite_hat: "new-outfit-full",
      icon_int_give: "new-outfit-full",
      icon_int_return: "new-outfit-full",
      icon_ext: "new-outfit-on",
      vo: {
        found: VO.IR8B,
        returned: VO.IR8A,
        fact: VO.FR9,
      },
    },
    "present": {
      name: "Present",
      sprite: "present-full",
      sprite_hat: "present-full",
      icon_int_give: "present-full",
      icon_int_return: "present-full",
      icon_ext: "present-on",
      vo: {
        found: VO.IR3B,
        returned: VO.IR3A,
      },
    },
    "samosas": {
      name: "Samosas",
      sprite: "samosas-full",
      sprite_hat: "samosas-full",
      icon_int_give: "samosas-full",
      icon_int_return: "samosas-full",
      icon_ext: "samosas-on",
      vo: {
        found: VO.IR6B,
        returned: VO.IR6A,
        fact: VO.FR6,
      },
    },
    "sitar": {
      name: "Sitar",
      sprite: "sitar-full",
      sprite_hat: "sitar-full",
      icon_int_give: "sitar-full",
      icon_int_return: "sitar-full",
      icon_ext: "sitar-on",
      vo: {
        found: VO.IR6B,
        returned: VO.IR6A,
        fact: VO.FR6,
      },
    },
  },
  payoffs: {
    default: { name: "Default"},
  },
  hidingspots: {
    "right-roof-edge": {
      hitarea: { x: 4641 / 2, y: 98 / 2 },
      foreground: { sprite: "right-roof-edge", x: 4641 / 2, y: 98 / 2 },
    },
    "red-table": {
      hitarea: { x: 4675 / 2, y: 803 / 2 },
      foreground: { sprite: "red-table", x: 4675 / 2, y: 803 / 2 },
    },
    "double-pots": {
      background: { sprite: "double-pots-back", x: 4292 / 2, y: 1026 / 2 },
      hitarea: { x: 4292 / 2, y: 1026 / 2 },
      foreground: { sprite: "double-pots-front", x: 4381 / 2, y: 1026 / 2 },
    },
    "middle-sign": {
      hitarea: { x: 1852 / 2, y: 208 / 2 },
      foreground: { sprite: "middle-sign", x: 2401 / 2, y: 208 / 2 },
    },
    "middle-tent-2": {
      hitarea: { x: 3351 / 2, y: 223 / 2 },
      foreground: { sprite: "middle-tent-2", x: 3351 / 2, y: 462 / 2 },
    },
    "middle-tent-1": {
      hitarea: { x: 1852 / 2, y: 208 / 2 },
      foreground: { sprite: "middle-tent-1", x: 1852 / 2, y: 386 / 2 },
    },
    "middle-counter": {
      hitarea: { x: 2728 / 2, y: 1048 / 2 },
      foreground: { sprite: "middle-counter", x: 2728 / 2, y: 1048 / 2 },
    },
    "yellow-tent": {
      hitarea: { x: 5174 / 2, y: 397 / 2 },
      foreground: { sprite: "yellow-tent", x: 5174 / 2, y: 397 / 2 },
    },
    "striped-tent": {
      hitarea: { x: 5205 / 2, y: 0 },
      foreground: { sprite: "striped-tent", x: 5205 / 2, y: 0 },
    },
    "right-shelf": {
      hitarea: { x: 5636 / 2, y: 650 / 2 },
      foreground: { sprite: "right-shelf", x: 5636 / 2, y: 650 / 2 },
    },
    "foodtable": {
      hitarea: { x: 1539 / 2, y: 1148 / 2 },
      foreground: { sprite: "foodtable", x: 1539 / 2, y: 1148 / 2 },
    },
    "teatable": {
      hitarea: { x: 3665 / 2, y: 1172 / 2 },
      foreground: { sprite: "teatable", x: 3665 / 2, y: 1172 / 2 },
    },
    "left-top-window": {
      hitarea: { x: 968 / 2, y: 165 / 2 },
      foreground: { sprite: "left-top-window", x: 968 / 2, y: 165 / 2 },
    },
    "red-tent": {
      hitarea: { x: 303 / 2, y: 288 / 2 },
      foreground: { sprite: "red-tent", x: 303 / 2, y: 288 / 2 },
    },
    "blue-tent": {
      hitarea: { x: 0, y: 0 },
      foreground: { sprite: "blue-tent", x: 0, y: 0 },
    },
  },
  npc: {
    name: "Raquel",
    poses: {
      neutral: {sprite: "npc-gaja-neutral", position: {x: -18, y: 0}},
      excited: {sprite: "npc-gaja-excited"},
    },
  },
  vo: {
    // give_quest: [VO.R1],
    show_items: [VO.R2, Constants.VO_SPACING, VO.R3],
    give_quest_idle: [VO.R4, VO.R5],
    return_items: [VO.R8, Constants.VO_SPACING, VO.R9],
    return_items_idle: [VO.R9],
    exterior: [VO.R6, Constants.VO_SPACING, VO.R7],
    exterior_idle: [VO.FR1, VO.FR2, VO.FR3, VO.FR4/* , VO.FR5 */],
    all_items_returned_idle: [VO.R13],
  },
  narratives: [
    {
      variations: [
// Level 1
        {
          hiddenitems: [
            {hidingspot: "blue-tent", item: { id: "present", scale: 0.6630, position: {x: 882 / 2, y: 1161 / 2}, rotation: 23 }},
            {hidingspot: "foodtable", item: { id: "balloon", scale: 0.636, position: {x: 653 / 2, y: 156 / 2}, rotation: 0 }},
            {hidingspot: "double-pots", item: { id: "cake", scale: 0.792, position: {x: 167 / 2, y: 150 / 2}, rotation: -8.8 }},
            {hidingspot: "right-shelf", item: { id: "laddu", scale: 0.7920, position: {x: 323 / 2, y: 222 / 2}, rotation: 0 }},
          ],
          itemslist: {
            give: {
              floatingItemsY: 10,
            },
          },
        },
      ],
      payoff: "default",
      vo: {
        all_items_returned: [VO.R11, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
// Level 2
        {
          hiddenitems: [
            {hidingspot: "right-roof-edge", item: { id: "present", scale: 0.64, position: {x: 51 / 2, y: 168 / 2}, rotation: -26.9 }},
            {hidingspot: "red-tent", item: { id: "kathputli", scale: 0.78, position: {x: 904 / 2, y: 378 / 2}, rotation: 14 }},
            {hidingspot: "teatable", item: { id: "cake", scale: 0.804, position: {x: 131 / 2, y: 116 / 2}, rotation: -21.9 }},
            {hidingspot: "middle-sign", item: { id: "boom-box", scale: 0.83, position: {x: 597 / 2, y: 124 / 2}, rotation: -8.5 }},
            {hidingspot: "middle-tent-2", item: { id: "samosas", scale: 0.676, position: {x: 116 / 2, y: 687 / 2}, rotation: -34.3 }},
          ],
          itemslist: {
            give: {
              columns: 3,
              floatingItemsY: -60,
            },
          },
        },
      ],
      payoff: "default",
      vo: {
        all_items_returned: [VO.R12, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
// Level 3
        {
          hiddenitems: [
            {hidingspot: "striped-tent", item: { id: "present", scale: 0.538, position: {x: 230 / 2, y: 1024 / 2}, rotation: -18.2 }},
            {hidingspot: "left-top-window", item: { id: "balloon", scale: 0.561, position: {x: 169 / 2, y: 216 / 2}, rotation: 2.3 }},
            {hidingspot: "blue-tent", item: { id: "cake", scale: 0.837, position: {x: 847 / 2, y: 1097 / 2}, rotation: 32.2 }},
            {hidingspot: "double-pots", item: { id: "sitar", scale: 1, position: {x: 427 / 2, y: 21 / 2}, rotation: -24.9 }},
            {hidingspot: "middle-tent-1", item: { id: "new-outfit", scale: 0.686, position: {x: 843 / 2, y: 578 / 2}, rotation: 0 }},
            {hidingspot: "foodtable", item: { id: "laddu", scale: 0.772, position: {x: 372 / 2, y: 69 / 2}, rotation: -6.7 }},
          ],
          itemslist: {
            give: {
              columns: 3,
              floatingItemsY: -60,
            },
          },
        },
      ],
      payoff: "default",
      vo: {
        all_items_returned: [VO.R11, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
// Level 4
        {
          hiddenitems: [
            {hidingspot: "double-pots", item: { id: "present", scale: 0.468, position: {x: 427 / 2, y: 55 / 2}, rotation: -13 }},
            {hidingspot: "striped-tent", item: { id: "balloon", scale: 0.642, position: {x: 502 / 2, y: 504 / 2}, rotation: 0, flipX: true }},
            {hidingspot: "middle-sign", item: { id: "cake", scale: 0.732, position: {x: 1201 / 2, y: -42 / 2}, rotation: 3 }},
            {hidingspot: "middle-tent-1", item: { id: "kathputli", scale: 0.867, position: {x: 498 / 2, y: 899 / 2}, rotation: -43 }},
            {hidingspot: "teatable", item: { id: "lassi-drink", scale: 0.66, position: {x: 53 / 2, y: 129 / 2}, rotation: -11.7 }},
            {hidingspot: "blue-tent", item: { id: "laddu", scale: 0.808, position: {x: 592 / 2, y: 599 / 2}, rotation: 0 }},
          ],
          itemslist: {
            give: {
              columns: 3,
              floatingItemsY: -60,
            },
          },
        },
      ],
      payoff: "default",
      vo: {
        all_items_returned: [VO.R12, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
// Level 5
        {
          hiddenitems: [
            {hidingspot: "middle-tent-1", item: { id: "present", scale: 0.601, position: {x: 511 / 2, y: 851 / 2}, rotation: -48.7 }},
            {hidingspot: "striped-tent", item: { id: "balloon", scale: 0.609, position: {x: 372 / 2, y: 1008 / 2}, rotation: 0, flipX: true }},
            {hidingspot: "foodtable", item: { id: "cake", scale: 0.872, position: {x: 324 / 2, y: 131 / 2}, rotation: 0 }},
            {hidingspot: "middle-counter", item: { id: "laddu", scale: 0.682, position: {x: 236 / 2, y: -9 / 2}, rotation: -2.2 }},
            {hidingspot: "double-pots", item: { id: "lassi-drink", scale: 0.602, position: {x: 225 / 2, y: -16 / 2}, rotation: 9.8 }},
            {hidingspot: "blue-tent", item: { id: "kathputli", scale: 0.895, position: {x: 726 / 2, y: 1092 / 2}, rotation: 13.2 }},
            {hidingspot: "middle-sign", item: { id: "new-outfit", scale: 0.836, position: {x: 1739 / 2, y: 209 / 2}, rotation: 24.3 }},
            {hidingspot: "right-roof-edge", item: { id: "boom-box", scale: 0.67, position: {x: 59 / 2, y: 185 / 2}, rotation: -11.9 }},
          ],
          itemslist: {
            give: {
              columns: 4,
              floatingItemsY: -60,
            },
          },
        },
      ],
      payoff: "default",
      vo: {
        all_items_returned: [VO.R11, Constants.VO_SPACING, VO.R13],
      },
    },
  ],
  bgm: "delhi-background-loop",
};
